// LocationIds for test suburbs in PH to be set to indexable in AU
const antipoloCity = 2061413; // Antipolo City
const legazpiCity = 2060201; // Legazpi City
export const experimentPHLocationIdsToBeIndexedInAU = [
  antipoloCity,
  legazpiCity,
];
export const experimentCountryCodesForOverridingHasExternalJobs = ['au'];

export const experimentPHPathsToBeIndexedInAU = [
  `/company-driver-jobs/in-Cavite-Calabarzon-PH`,
  `/driver-jobs/in-San-Fernando-Pampanga-PH`,
  `/company-driver-jobs/in-Santa-Rosa-City-Laguna-PH`,
  `/driver-jobs/in-Cebu-City-Cebu-PH`,
  `/batangas+driver-jobs/in-Mandaluyong-City-Metro-Manila-PH`,
  `/driver-jobs/in-Batangas-Calabarzon-PH`,
  `/driver-jobs/in-Pasay-City-Metro-Manila-PH`,
  `/nueva-ecija-driver-jobs/in-Makati-City-Metro-Manila-PH`,
  `/receptionist-jobs/in-Cebu-City-Cebu-PH`,
  `/clinic-receptionist-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/restaurant-receptionist-jobs/in-Pasay-City-Metro-Manila-PH`,
  `/restaurant+receptionist-jobs/in-Philippines`,
  `/medical-receptionist-jobs/in-Cebu-Central-Visayas-PH`,
  `/supermarket-cashier-jobs/in-Malabon-City-Metro-Manila-PH`,
  `/hotel-cashier-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/store-cashier-jobs/in-San-Juan-City-Metro-Manila-PH`,
  `/hotel+barista-jobs/in-Antipolo-City-Rizal-PH`,
  `/barista-jobs/in-Dagupan-City-Pangasinan-PH`,
  `/starbucks-barista-jobs/in-Marikina-City-Metro-Manila-PH`,
  `/barista-for-starbucks-jobs/in-Pasay-City-Metro-Manila-PH/full-time`,
  `/barista-jobs/in-Bicol-Region-PH`,
  `/government-jobs/in-Zamboanga-Peninsula-PH`,
  `/tanza-jobs/in-Philippines`,
  `/jobs/in-Cebu-City-Cebu-PH/part-time`,
  `/government-jobs/in-Pasig-City-Metro-Manila-PH`,
  `/restaurant-staff-jobs/in-Manila-City-Metro-Manila-PH`,
  `/english-teacher-jobs/in-Cebu-City-Cebu-PH`,
  `/production-worker-jobs/in-Cebu-City-Cebu-PH`,
  `/civil-service-jobs/in-Northern-Mindanao-PH`,
  `/TDCX-jobs/in-Cebu-Central-Visayas-PH`,
  `/factory-jobs/in-Bulacan-Central-Luzon-PH`,
  `/executive-driver-jobs/in-Taguig-City-Metro-Manila-PH`,
  `/part-time-job-jobs/in-Las-Pinas-City-Metro-Manila-PH`,
  `/jobs/in-Las-Pinas-City-Metro-Manila-PH/part-time`,
  `/office-jobs/in-Negros-Oriental-Central-Visayas-PH`,
  `/housekeeping+no+experience-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/production-worker-jobs/in-Valenzuela-City-Metro-Manila-PH`,
  `/store-jobs/in-Bulacan-Central-Luzon-PH`,
  `/MIESCOR-jobs/in-Pasig-City-Metro-Manila-PH`,
  `/hotel-restaurant-management-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/VXI-Global-Solutions-jobs/in-Davao-PH`,
  `/clark-jobs/in-Angeles-City-Pampanga-PH`,
  `/mandaue-jobs/in-Cebu-Central-Visayas-PH`,
  `/urgent-jobs/in-Baguio-City-Benguet-PH`,
  `/urgent-hiring-jobs/in-Makati-City-Metro-Manila-PH`,
  `/jobs/in-La-Union-Ilocos-Region-PH`,
  `/production-worker-jobs/in-Central-Visayas-PH`,
  `/part-time-home-based-jobs/in-Cebu-City-Cebu-PH`,
  `/local-call-center-jobs/in-Pasig-City-Metro-Manila-PH`,
  `/jobs/in-San-Pablo-City-Laguna-PH`,
  `/civil-service-jobs/in-Ilocos-Region-PH`,
  `/teacher-i-jobs/in-Ilocos-Region-PH`,
  `/TaskUs-jobs/in-Antipolo-City-Rizal-PH`,
  `/lipa-batangas-jobs/in-Lipa-City-Batangas-PH`,
  `/Jollibee-Foods-Corporation-jobs/in-Cebu-City-Cebu-PH`,
  `/hospital-jobs/in-Caloocan-City-Metro-Manila-PH`,
  `/teacher-jobs/in-Cebu-City-Cebu-PH`,
  `/tamiya-chuo-philippines-or-inc-jobs/in-Cebu-Central-Visayas-PH`,
  `/work-from-home-jobs/in-Santa-Rosa-City-Laguna-PH`,
  `/tagalog-jobs/in-Davao-PH`,
  `/resort+world-jobs/in-Manila-City-Metro-Manila-PH`,
  `/home-based-call-center-jobs/in-Davao-PH`,
  `/fcie-jobs/in-Calabarzon-&-Mimaropa-PH`,
  `/google+operation+center-jobs/in-Pasig-City-Metro-Manila-PH`,
  `/jobs/in-Bacolod-City-Negros-Occidental-PH`,
  `/Accenture-jobs/in-Bicol-Region-PH`,
  `/banking-jobs/in-Makati-City-Metro-Manila-PH`,
  `/direct-hiring-jobs/in-Cebu-City-Cebu-PH`,
  `/jobs/in-Oriental-Mindoro-Mimaropa-PH`,
  `/no-experience-jobs/in-Pasay-City-Metro-Manila-PH`,
  `/job-fair-jobs/in-Manila-City-Metro-Manila-PH`,
  `/no-experience-jobs/in-Cagayan-de-Oro-Misamis-Oriental-PH`,
  `/no-experience-jobs/in-Batangas-Calabarzon-PH`,
  `/Airbnb-jobs/in-Philippines`,
  `/admin-staff-jobs/in-Cavite-Calabarzon-PH`,
  `/laguna-technopark-jobs/in-Santa-Rosa-City-Laguna-PH`,
  `/senior-citizens-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/working-student-jobs/in-Cebu-City-Cebu-PH`,
  `/government-jobs/in-Caraga-PH`,
  `/housekeeping-jobs/in-Cavite-Calabarzon-PH`,
  `/medical-technologist-jobs/in-Cebu-City-Cebu-PH`,
  `/Shopee-jobs/in-Taguig-City-Metro-Manila-PH`,
  `/hotel-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/Reed-Elsevier-jobs/in-Iloilo-City-Iloilo-PH`,
  `/jobs-in-engineering/in-Central-Visayas-PH`,
  `/jobs/in-Tarlac-Central-Luzon-PH`,
  `/coca-cola-femsa-philippines-or-inc-jobs/in-Pangasinan-Ilocos-Region-PH`,
  `/architect-jobs/in-Davao-City-Davao-del-Sur-PH`,
  `/jobs/in-Palawan-Mimaropa-PH`,
  `/caregiver-jobs/in-Cebu-Central-Visayas-PH`,
  `/now-hiring-for-jpmorgan-chase-co-bgc-or-taguig-fraud-specialists-jobs/in-Manila-City-Metro-Manila-PH`,
  `/department-of-education-jobs/in-Bicol-Region-PH`,
  `/caregiver-jobs/in-Cebu-City-Cebu-PH`,
  `/dole-philippines-or-inc-jobs/in-Camarines-Sur-Bicol-Region-PH`,
  `/bpo-jobs/in-Pasay-City-Metro-Manila-PH`,
  `/jobs/in-Olongapo-City-Zambales-PH`,
  `/fil-sino-manpower-services-or-inc-jobs/in-Cebu-City-Cebu-PH`,
  `/agency-jobs/in-Manila-City-Metro-Manila-PH`,
  `/virtual-assistant-jobs/in-Cebu-City-Cebu-PH`,
  `/urgent-jobs/in-Davao-City-Davao-del-Sur-PH`,
  `/alorica-is-hiring-jobs/in-Pasay-City-Metro-Manila-PH`,
  `/golden-horizon-placement-agency-or-inc-jobs/in-Iloilo-City-Iloilo-PH`,
  `/dole-philippines-or-inc-jobs/in-Bicol-Region-PH`,
  `/no-experience-jobs/in-Iloilo-City-Iloilo-PH`,
  `/boracay-jobs/in-Philippines`,
  `/m-lhuillier-food-products-or-inc-jobs/in-Davao-City-Davao-del-Sur-PH`,
  `/puregold-price-club-or-inc-jobs/in-Tacloban-City-Leyte-PH`,
  `/factory-jobs/in-Cebu-City-Cebu-PH`,
  `/factory-worker-jobs/in-Pampanga-Central-Luzon-PH`,
  `/national-government-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/jobs/in-Zamboanga-del-Norte-Zamboanga-Peninsula-PH`,
  `/no-experience-jobs/in-Legazpi-City-Albay-PH`,
  `/work-from-home-jobs/in-Legazpi-City-Albay-PH`,
  `/industrial-engineer-jobs/in-Cebu-City-Cebu-PH`,
  `/government-jobs/in-Eastern-Visayas-PH`,
  `/manila+international+airport-jobs/in-Philippines`,
  `/factory+worker+no+experience-jobs/in-Marikina-City-Metro-Manila-PH`,
  `/jobs/in-Batangas-Calabarzon-PH`,
  `/Work-At-Home-jobs/in-Bulacan-Central-Luzon-PH`,
  `/government-jobs/in-Iloilo-City-Iloilo-PH`,
  `/virtual-jobs/in-Angeles-City-Pampanga-PH`,
  `/jobs/in-Laguna-Calabarzon-PH`,
  `/bdo-network-bank-jobs/in-Makati-City-Metro-Manila-PH`,
  `/m-lhuillier-food-products-or-inc-jobs/in-Northern-Mindanao-PH`,
  `/job+fair-jobs/in-Pasig-City-Metro-Manila-PH`,
  `/agency-jobs/in-Cebu-City-Cebu-PH`,
  `/ubiquity+global+services+inc-jobs/in-Manila-City-Metro-Manila-PH`,
  `/tailor-jobs/in-Manila-City-Metro-Manila-PH`,
  `/civil+engineer+part+time-jobs/in-Metro-Manila-PH`,
  `/company-driver-jobs/in-Cebu-City-Cebu-PH`,
  `/lapu-lapu-city-jobs/in-Cebu-City-Cebu-PH`,
  `/jobs-in-call-centre-customer-service/in-General-Santos-City-South-Cotabato-PH`,
  `/government-jobs/in-Butuan-City-Agusan-del-Norte-PH`,
  `/monday-friday-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/iqor-philippines-or-inc-jobs/in-Pampanga-Central-Luzon-PH`,
  `/bank-jobs/in-Davao-City-Davao-del-Sur-PH`,
  `/freelance-jobs/in-Cebu-City-Cebu-PH`,
  `/mystery-shopper-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/no-experience-required-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/philippine-airport-ground-support-solutions-or-inc-jobs/in-General-Santos-City-South-Cotabato-PH`,
  `/caregiver-jobs/in-Central-Visayas-PH`,
  `/urgent-jobs/in-Cebu-City-Cebu-PH`,
  `/taytay-jobs/in-Rizal-Calabarzon-PH`,
  `/Civil-Service-Commission-jobs/in-Bicol-Region-PH`,
  `/web-developer-government-jobs/in-Metro-Manila-PH`,
  `/housekeeper-jobs/in-Paranaque-City-Metro-Manila-PH`,
  `/metro-jobs/in-Cebu-City-Cebu-PH`,
  `/national-government-jobs/in-Santa-Rosa-City-Laguna-PH`,
  `/pdea-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/sales-promodiser-jobs/in-Quezon-City-Metro-Manila-PH`,
  `/laboratory-jobs/in-Davao-PH`,
];
